import { Router, Route, hashHistory, IndexRoute } from 'react-router';

const config = require(`./config.${process.env.APP_ENV}.json`);

export default config;


// WEBPACK FOOTER //
// ./config/index.js